module.exports = __webpack_public_path__ + "static/media/resource1.28b31422.svg";